"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _has = _interopRequireDefault(require("lodash/has"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _IconPropTypes = _interopRequireDefault(require("./IconPropTypes"));

var _iconDefs = _interopRequireDefault(require("./icon-defs"));

(function () {
  var enterModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).enterModule;
  enterModule && enterModule(module);
})();

var Icon =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(Icon, _Component);

  function Icon(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Icon);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Icon).call(this, props));
    var name = props.name,
        iconDefinitions = props.iconDefinitions;
    _this._ICONS = (0, _objectSpread2.default)({}, _iconDefs.default, iconDefinitions);

    if (!(0, _has.default)(_this._ICONS, name)) {
      throw new Error("'".concat(name, "' is not a valid icon name. Please use a defined name from the icon definitions available."));
    }

    return _this;
  }

  (0, _createClass2.default)(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          name = _this$props.name,
          role = _this$props.role,
          size = _this$props.size;
      var classes = (0, _classnames.default)('Icon', "Icon-".concat(name), className);
      return _react.default.createElement("svg", {
        className: classes,
        role: role,
        viewBox: "0 0 1024 1024",
        width: "".concat(size, "px"),
        height: "".concat(size, "px")
      }, _react.default.createElement("path", {
        d: this._ICONS[name]
      }));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Icon;
}(_react.Component);

exports.default = Icon;
(0, _defineProperty2.default)(Icon, "propTypes", _IconPropTypes.default);
(0, _defineProperty2.default)(Icon, "defaultProps", {
  role: 'presentation',
  size: 20
});
;

(function () {
  var reactHotLoader = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).default;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(Icon, "Icon", "/Users/mprzybylski/Work/SpotHero/fe-ui/src/Icon/Icon.jsx");
})();

;

(function () {
  var leaveModule = (typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal : require('react-hot-loader')).leaveModule;
  leaveModule && leaveModule(module);
})();